import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../lib/utils.js";
const Textarea = React.forwardRef(({ className, ...props }, ref) => (_jsx("textarea", { ref: ref, className: cn("flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-placeholder focus-visible:focus-ring disabled:cursor-not-allowed disabled:opacity-50", className), ...props })));
Textarea.displayName = "Textarea";
export { Textarea };
//# sourceMappingURL=textarea.js.map